"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readTextFile = void 0;
function readTextFile(file, parse = value => value) {
    const reader = new FileReader();
    const promise = new Promise(resolve => {
        reader.onload = ({ target }) => {
            var _a;
            if (!target || target.readyState !== 2) {
                return resolve(undefined);
            }
            if (target.error) {
                return resolve({ error: 'An error occurred while reading the file.' });
            }
            try {
                resolve({ value: parse((_a = target.result) === null || _a === void 0 ? void 0 : _a.toString()) });
            }
            catch (_b) {
                resolve({ error: 'Unable to parse the selected file.' });
            }
        };
    });
    reader.readAsText(file);
    return promise;
}
exports.readTextFile = readTextFile;
//# sourceMappingURL=readTextFile.js.map